export default "__VITE_ASSET__b6$eCgoP__"